import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408fe88a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi_channel" }
const _hoisted_2 = { class: "multi_selects_option" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "multi_center" }
const _hoisted_6 = { class: "multi_center_tags" }
const _hoisted_7 = { class: "multi_icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_draggable, {
      list: _ctx.multiList,
      onChange: _ctx.getMulti,
      onDrop: _ctx.dragDrop
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "multi",
            key: index
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_select, {
                class: "multi_selects",
                size: "large",
                value: item.language,
                "onUpdate:value": ($event: any) => ((item.language) = $event),
                "option-label-prop": "label",
                onChange: (value) => _ctx.getChannel(value, index),
                placeholder: "选择语言"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageList, (litem, lindex) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: lindex,
                      value: lindex,
                      label: litem.ch_name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", null, _toDisplayString(litem.ch_name), 1),
                          _createElementVNode("img", {
                            src: litem.image_url,
                            alt: ""
                          }, null, 8, _hoisted_3)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "onChange"]),
              _withDirectives(_createElementVNode("img", {
                class: "multi_selects_icon",
                src: item.selectImg,
                alt: ""
              }, null, 8, _hoisted_4), [
                [_vShow, item.selectImg]
              ]),
              _createVNode(_component_a_input, {
                value: item.alias,
                "onUpdate:value": ($event: any) => ((item.alias) = $event),
                class: "multi_inputs",
                size: "large",
                placeholder: "语言别名",
                onChange: ($event: any) => (_ctx.getStrLength(item, item.alias))
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "multi_inputs_icon",
                    "icon-class": "alias"
                  })
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (_ctx.getSelectLive(0, index)),
                  class: _normalizeClass(item.selectLive == 0 ? 'tags_btn' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("选择直播间")
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"]),
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (_ctx.getSelectLive(1, index)),
                  class: _normalizeClass(item.selectLive == 1 ? 'tags_btn' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新建直播间")
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"])
              ]),
              _withDirectives(_createVNode(_component_a_select, {
                class: "multi_select",
                size: "large",
                "show-search": "",
                placeholder: "选择已有直播间",
                value: item.select,
                "onUpdate:value": ($event: any) => ((item.select) = $event)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (res, resIndex) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: res.id,
                      onClick: ($event: any) => (_ctx.getSelect(index, resIndex)),
                      value: res.title
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(res.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value"]), [
                [_vShow, item.selectLive == 0]
              ]),
              _withDirectives(_createVNode(_component_a_input, {
                class: "multi_input",
                size: "large",
                placeholder: "输入直播间名称",
                value: item.input,
                "onUpdate:value": ($event: any) => ((item.input) = $event)
              }, null, 8, ["value", "onUpdate:value"]), [
                [_vShow, item.selectLive == 1]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_svg_icon, {
                onClick: _ctx.toAdd,
                class: "add",
                "icon-class": "add"
              }, null, 8, ["onClick"]),
              (index !== 0)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.toDelete(index)),
                    class: "del",
                    "icon-class": "del"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["list", "onChange", "onDrop"])
  ]))
}